export default __webpack_public_path__ + "static/media/ic_sky.b366a162.svg";